import { render } from "./selectItemModel.vue?vue&type=template&id=552034a5"
import script from "./selectItemModel.vue?vue&type=script&lang=js"
export * from "./selectItemModel.vue?vue&type=script&lang=js"

import "./selectItemModel.vue?vue&type=style&index=0&id=552034a5&lang=sass"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__